import { createContext } from 'react';

import type useGlobalModals from '~/components/GlobalModals/hooks/useGlobalModals';

type GlobalModalsApi = ReturnType<typeof useGlobalModals>;

export type ModalCoordinationContextType = {
  /** URL-driven, app-wide modals (e.g. `connected_accounts`, `login`). */
  global: GlobalModalsApi;
  /** Shared local-state modal stack scoped to the subscription-management surface. */
  local: GlobalModalsApi;
};

export const ModalCoordinationContext = createContext<ModalCoordinationContextType | undefined>(undefined);
ModalCoordinationContext.displayName = 'ModalCoordinationContext';
